import {
  Box,
  Input,
  Button,
  Text,
  Progress,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from "@chakra-ui/react";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as N from "../../../../utilities/notifications";
import { patchData, postData } from "../../../../utilities/axios";
import { updateUserDetails } from "../../../../redux/actions/user";
import { useRef } from "react";
import axios from "axios";

const UploadVideo = ({ profile }) => {
  const [file, setFile] = useState(undefined);
  const [percentProgress, setPercentProgress] = useState(0);
  const [completedUpload, setCompletedUpload] = useState(false);
  const [uploading, setUploading] = useState(false);
  const token = useSelector((state) => state.user.JWTToken);
  const user = useSelector((state) => state.user);
  const toast = useToast();
  const dispatch = useDispatch();
  const hiddenFileInput = useRef();
  const { profileVideo } = profile;

  const {
    isOpen: deleteOpen,
    onClose: closeDelete,
    onOpen: openDelete,
  } = useDisclosure();

  const saveNewVideo = async (url) => {
    try {
      if (!url) {
        return;
      }

      const userUpdateProfile = {
        profileId: profile.profileId,
        practitionerType: "therapist",
        profileVideo: url,
      };

      await patchData(
        token,
        userUpdateProfile,
        `${process.env.NEXT_PUBLIC_NEW_USER_URL}profile`
      );
      await dispatch(
        updateUserDetails({
          therapistProfile: {
            ...profile,
            ...userUpdateProfile,
          },
        })
      );

      toast(N.updateDetailsSuccess);
    } catch (error) {
      console.error("PROBLEM SAVING NEW VIDEO", error);
      toast(N.updateDetailsFail(error));
    }
  };

  const handleSetVideo = (newFile) => {
    if (!newFile) return;
    if (!newFile.type.startsWith("video")) {
      return;
    }
    setFile(newFile);
    const ext = newFile.name.split(".").pop();
    uploadVideo(
      `profiles/${user.cognitoId}/intro_vid_${profile.profileId}.${ext}`,
      newFile
    );
  };

  const uploadVideo = async (newFileKey, newFile) => {
    if (newFile.size / 1000 / 1000 >= 100) {
      toast(N.genericFail("Video is too large, please select one under 100MB"));
      return;
    }
    const response = await postData(
      token,
      {
        type: "video",
        contentType: newFile.type,
      },
      `${process.env.NEXT_PUBLIC_NEW_USER_URL}profile/media`,
      process.env.NEXT_PUBLIC_NEW_USER_APIKEY
    );

    await axios.put(response.s3PutDetails.url, newFile, {
      headers: {
        ...response.s3PutDetails.headers,
        "Access-Control-Allow-Origin": "*",
      },
      onUploadProgress: (progress) => {
        setPercentProgress((progress.loaded / newFile.size) * 100);
      },
    });

    await saveNewVideo(response.publicUrl);
    setCompletedUpload(true);
  };

  const deleteVideo = async () => {
    try {
      const userUpdateProfile = {
        profileId: profile.profileId,
        practitionerType: "therapist",
        profileVideo: null,
      };

      await patchData(
        token,
        userUpdateProfile,
        `${process.env.NEXT_PUBLIC_NEW_USER_URL}profile`
      );
      await dispatch(
        updateUserDetails({
          therapistProfile: {
            ...profile,
            ...userUpdateProfile,
          },
        })
      );

      toast(N.updateDetailsSuccess);
      closeDelete();
    } catch (error) {
      console.error("PROBLEM DELETING VIDEO", error);
      toast(N.updateDetailsFail(error));
    }
  };

  return (
    <Box>
      <Modal isOpen={deleteOpen} onClose={closeDelete} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete intro video?</ModalHeader>
          <ModalCloseButton />
          <ModalBody className="flex flex-col gap-4">
            <p>Are you sure you wish to continue?</p>
          </ModalBody>

          <ModalFooter justifyContent="space-between" display="flex">
            <Button
              className="text-brand"
              onClick={() => {
                closeDelete();
              }}
            >
              Go back
            </Button>
            <Button
              className="bg-red-500 hover:bg-red-400 rounded-full px-4 py-2 text-white font-bold transition"
              onClick={deleteVideo}
            >
              Delete
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Box py="24px" display="flex" alignItems="center">
        <Input
          type="file"
          ref={hiddenFileInput}
          onChange={(e) => {
            if (e.target && e.target.files?.length > 0) {
              handleSetVideo(e.target.files[0]);
            }
          }}
          style={{ display: "none" }}
        />
        <Button onClick={() => hiddenFileInput.current.click()}>
          Choose file
        </Button>
        {profileVideo && <Button onClick={openDelete}>Delete video</Button>}
      </Box>

      {file && (
        <Box py="24px">
          <Box py="24px">
            <Progress
              value={parseInt(percentProgress)}
              size="sm"
              colorScheme="pink"
              isIndeterminate={uploading}
            />
          </Box>
          {uploading && (
            <Text textStyle="h6">
              Please wait whilst we upload your video....
            </Text>
          )}

          {completedUpload && (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Text textStyle="h6">Video uploaded!</Text>
            </Box>
          )}

          {percentProgress > 0 && percentProgress < 100 && (
            <Text textStyle="h6">
              Uploading... {Math.ceil(percentProgress)}%
            </Text>
          )}
        </Box>
      )}
    </Box>
  );
};

export default UploadVideo;
